/**
 * useDebouncedValue — returns `value` after it has been stable for `delayMs`.
 *
 * Used to debounce the shops search input so the seller-finder query
 * (`GET /marketplace/sellers?q=…`) only re-issues once the user pauses
 * typing, rather than on every keystroke. Trailing-edge debounce; the timer
 * is reset on each change and cleared on unmount.
 */
import { useEffect, useState } from "react";

/** Default debounce window for the search box (ms). */
export const SEARCH_DEBOUNCE_MS = 300;

export function useDebouncedValue<T>(
  value: T,
  delayMs: number = SEARCH_DEBOUNCE_MS,
): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
